import api from './api'

const acceptInvitation = (invitationToken: string): Promise<unknown> =>
    api<unknown>({ method: 'PUT', path: `/auth/invitation/accept/${invitationToken}` })

export default acceptInvitation
